import React, { useEffect, useState } from "react";
import { Modal, Button, Card, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { addDays, startOfDay, subDays } from "date-fns";
import { getAutoavaliacaoCampos } from "pages/apps/Autoavaliacao/Formulario/FormularioApi";
import axios from "axios";
import { useWeeklyAutoavaliacao } from "hooks/useWeeklyAutoavaliacao";
import { useUser } from "hooks";
import BackgroundAlert from "./BackgroundAlert";

interface IPerguntaProps {
  enunciado: string;
  labels: string[];
  value?: number;
  onChange: (pressed: number) => void;
}

interface ICampo {
  id: number;
  titulo: string;
  peso: number;
  opcoes: {
    valor: number;
    label: string;
  }[];
}

const defaultLabels = [
  "Discordo completamente",
  "Discordo parcialmente",
  "Neutro",
  "Concordo parcialmente",
  "Concordo completamente",
];

export function responderAutoavaliacaoBatch(
  data: {
    autoavaliacaocampo_id: number | null;
    resposta: number | null;
    observacao: string;
  }[],
) {
  return axios.post("/autoavaliacao-resposta", data);
}

function Pergunta({ enunciado, onChange, labels, value }: IPerguntaProps) {
  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title className="mb-0">{enunciado}</Card.Title>
      </Card.Header>

      <Card.Body>
        <div
          className="d-flex w-100"
          style={{
            gap: 8,
          }}
        >
          {[-2, -1, 0, 1, 2].map((valor, index) => (
            <button
              key={valor}
              type="button"
              onClick={() => onChange(valor)}
              className={`btn ${
                value === valor
                  ? "btn-primary"
                  : valor === -2
                  ? "btn-outline-danger"
                  : valor === -1
                  ? "btn-outline-danger"
                  : valor === 0
                  ? "btn-outline-warning"
                  : valor === 1
                  ? "btn-outline-success"
                  : valor === 2
                  ? "btn-outline-success"
                  : "btn-outline-primary"
              }`}
              style={{
                flex: 1,
                minWidth: 0,
                whiteSpace: "normal",
                wordBreak: "break-word",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                minHeight: 70,
                padding: "12px 8px",
              }}
            >
              {labels[index] === "" ? defaultLabels[index] : labels[index]}
            </button>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

export function WeeklyAutoavaliacaoModal() {
  const [observacoes, setObservacoes] = useState("");
  const [perguntas, setPerguntas] = useState<ICampo[]>([]);
  const [respostas, setRespostas] = useState<Record<number, number>>({});
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const { user } = useSelector((state: any) => ({
    user: state.Auth.user,
  }));
const {
  status,
  openModal,
  closeModal,
  answerAutoavaliacao,
} = useWeeklyAutoavaliacao();
  useEffect(() => {
    async function carregarPerguntas() {
      const response = await getAutoavaliacaoCampos();
      setPerguntas(response.data);
    }

    carregarPerguntas();
  }, []);

  useEffect(() => {
    const hoje = new Date();
    const diaDaSemana = hoje.getDay();

    let sextaInicioCicloAtual;

    if (diaDaSemana === 5) {
      sextaInicioCicloAtual = startOfDay(hoje);
    } else {
      const diasDesdeSexta = ((diaDaSemana + 1) % 7) + 1;
      sextaInicioCicloAtual = startOfDay(subDays(hoje, diasDesdeSexta));
    }

    const sextaInicioCicloAnterior = subDays(sextaInicioCicloAtual, 7);
    const quintaFechaCicloAnterior = addDays(sextaInicioCicloAnterior, 6);

    setResponsePeriod(
      `Período: ${sextaInicioCicloAnterior.toLocaleDateString()} - ${quintaFechaCicloAnterior.toLocaleDateString()}`,
    );
  }, []);

  const [responsePeriod, setResponsePeriod] = useState("");

  const colaborador_id = user?.usuario?.colaborador?.id;

  useEffect(() => {
    const hoje = new Date();
    const diaDaSemana = hoje.getDay();

    let sextaInicioCicloAtual;

    if (diaDaSemana === 5) {
      sextaInicioCicloAtual = startOfDay(hoje);
    } else {
      const diasDesdeSexta = ((diaDaSemana + 1) % 7) + 1;
      sextaInicioCicloAtual = startOfDay(subDays(hoje, diasDesdeSexta));
    }

    const sextaInicioCicloAnterior = subDays(sextaInicioCicloAtual, 7);
    const quintaFechaCicloAnterior = addDays(sextaInicioCicloAnterior, 6);

    setResponsePeriod(
      `Período: ${sextaInicioCicloAnterior.toLocaleDateString()} - ${quintaFechaCicloAnterior.toLocaleDateString()}`,
    );
  }, []);

  function responderPergunta(id: number, resposta: number) {
    setRespostas((old) => ({
      ...old,
      [id]: resposta,
    }));
  }
  console.log(user);
  if (!colaborador_id) {
    return null;
  }

  if (
    !user.usuario?.gruposistema.funcoes.map((f: { id: number }) => f.id).includes(159)
  ) {
    console.log("funcao");
    return null;
  }

  // Sem resposta nenhuma o backend não grava registro e o modal voltaria
  // a abrir no próximo carregamento.
  const todasRespondidas =
    perguntas.length > 0 &&
    perguntas.every((pergunta) => respostas[pergunta.id] !== undefined);

  async function enviar() {
    if (!todasRespondidas) return;

    const payload: {
      autoavaliacaocampo_id: number | null;
      resposta: number | null;
      observacao: string;
    }[] = Object.entries(respostas).map(([id, resposta]) => ({
      autoavaliacaocampo_id: Number(id),
      resposta,
      observacao: "",
    }));

    if (observacoes.trim()) {
      payload.push({
        autoavaliacaocampo_id: null,
        resposta: null,
        observacao: observacoes.trim(),
      });
    }

    try {
      await answerAutoavaliacao(payload);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.status === 409
          ? "Você já respondeu a autoavaliação dessa semana."
          : error?.response?.data?.error ||
              "Não foi possível enviar sua autoavaliação. Tente novamente.",
      );
      setAlertVisible(true);
    }
  }

  return (
    <>
      {alertVisible && (
        <BackgroundAlert
          type="danger"
          closeModal={setAlertVisible}
          modalText={alertMessage}
        />
      )}
      <Modal
        show={status === "open"}
        onHide={closeModal}
        size="lg"
        dialogClassName="modal-dialog-centered"
      >
        <Modal.Header closeButton>
          <div>
            <Modal.Title>
              Como você avalia seu desempenho essa semana?
            </Modal.Title>

            <span
              style={{
                fontSize: 14,
                color: "#6c757d",
                marginTop: 4,
                userSelect: "none",
              }}
            >
              {responsePeriod}
            </span>
          </div>
        </Modal.Header>

        <Modal.Body>
          <p
            style={{
              textAlign: "center",
              marginBottom: 24,
            }}
          >
            Reflita sobre suas atividades e selecione a resposta que melhor
            representa sua autoavaliação.
          </p>

          {/* Perguntas carregadas da API */}

          {perguntas.map((pergunta) => (
            <Pergunta
              key={pergunta.id}
              enunciado={pergunta.titulo}
              labels={pergunta.opcoes
                .sort((a, b) => a.valor - b.valor)
                .map((o) => o.label)}
              value={respostas[pergunta.id]}
              onChange={(valor) => responderPergunta(pergunta.id, valor)}
            />
          ))}

          <Form.Group className="mt-4">
            <Form.Label>Observações (opcional)</Form.Label>

            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Caso queira, descreva algum contexto, dificuldade, conquista ou qualquer observação sobre sua semana."
              value={observacoes}
              onChange={(e) => setObservacoes(e.target.value)}
            />
          </Form.Group>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 24,
              gap: 16,
            }}
          >
            <Button onClick={closeModal} variant="light">Cancelar</Button>

            <Button onClick={enviar} disabled={!todasRespondidas}>
              Enviar
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {status === "button" && (
        <Button
          variant="primary"
          className="floating-button"
          onClick={openModal}
        >
          <i
            className="mdi mdi-clipboard-text-outline"
            style={{ fontSize: 32 }}
          />
        </Button>
      )}
    </>
  );
}
